var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDiamondLight = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500.3 227.7C515.9 243.3 515.9 268.7 500.3 284.3L284.3 500.3C268.7 515.9 243.3 515.9 227.7 500.3L11.72 284.3C-3.905 268.7-3.905 243.3 11.72 227.7L227.7 11.72C243.3-3.905 268.7-3.905 284.3 11.72L500.3 227.7zM34.34 250.3C31.22 253.5 31.22 258.5 34.34 261.7L250.3 477.7C253.5 480.8 258.5 480.8 261.7 477.7L477.7 261.7C480.8 258.5 480.8 253.5 477.7 250.3L261.7 34.34C258.5 31.22 253.5 31.22 250.3 34.34L34.34 250.3z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDiamondLight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/diamond-light.436474db.svg";
export { ForwardRef as ReactComponent };